import i18n from '@/i18n.js'

export default {
  defaulticons: [],

  tableHeaders: [
    {text: 'ID', value: 'default_icon_id'},
    {text: 'Icon Key', value: 'icon_key'},
    {text: 'Actions', value: 'actions', sortable: false}
  ],

  selectedDefaulticon: {},

  fields: [
    {
      name: 'icon_key',
      type: 'text',
      label: 'Icon Key',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory')
      ],
      autofocus: true,
      required: true,
      hide: false,
      value: null,
      hint: 'Enter the Material Design Icon key (e.g., mdi-eye-outline)'
    }
  ]
}
